import jQuery from 'jquery';
import Immutable from 'immutable';
import {browserHistory} from 'react-router'
import _ from 'lodash'
import {signOut} from './access'
var config = require('config');

/**
 * requestData is empty if the requestMethod is 'GET'
 *
 * @param requestUrl
 * @param requestMethod
 * @param requestData
 * @param callback
 * @returns {*}
 */
export function request(requestUrl, requestMethod, requestData, callback, requestHeaders = {}, external = false) {
  if (!external && !sessionStorage.getItem('auth')) {
    signOut();
  }

  let extraHeaders = Object.assign({Authorization: sessionStorage.getItem('auth')}, requestHeaders);
  let headers = Immutable.Map(config.default.headers).merge(Immutable.Map(extraHeaders)).toObject();
  headers['Accept-Language'] = config.default.locale[sessionStorage.getItem('locale')];
  var $ = jQuery;
  return $.ajax({
      method: requestMethod,
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      url: requestUrl,
      data: !_.isEmpty(requestData) ? JSON.stringify(requestData) : null,
      headers: headers
    })
    .success(function (data) {
      callback(data, 200);
    }).error(
      function (data) {
        if (data.status == 401) {
          signOut();
        }
        let responseText = data.responseText;
        var parsedData;
        try {
          parsedData = JSON.parse(responseText)
        } catch (e) {

        }
        var responseData;
        responseData = parsedData ? parsedData : responseText;
        callback(responseData, data.status)
      }
    )
}



// WEBPACK FOOTER //
// ./src/helpers/request.js